import { NavLink } from 'react-router-dom';
import { LayoutGrid, ShoppingCart, Package } from 'lucide-react';
import { useStore } from '../store/useStore';
import { cn } from '@/lib/utils';

export function BottomNav() {
  const cartCount = useStore(state => state.cartCount);

  return (
    <nav className="fixed bottom-0 left-0 right-0 flex justify-around items-center bg-background border-t py-2 pb-[calc(0.5rem+env(safe-area-inset-bottom))] z-50">
      <NavLink
        to="/catalog"
        className={({ isActive }) =>
          cn(
            "flex flex-col items-center gap-1 px-4 py-2 text-xs transition-colors",
            isActive ? "text-primary" : "text-muted-foreground"
          )
        }
      >
        <LayoutGrid className="h-6 w-6" />
        <span>Каталог</span>
      </NavLink>

      <NavLink
        to="/cart"
        className={({ isActive }) =>
          cn(
            "flex flex-col items-center gap-1 px-4 py-2 text-xs transition-colors",
            isActive ? "text-primary" : "text-muted-foreground"
          )
        }
      >
        <div className="relative">
          <ShoppingCart className="h-6 w-6" />
          {cartCount > 0 && (
            <span className="absolute -top-1.5 -right-1.5 bg-destructive text-destructive-foreground text-[10px] font-bold px-1.5 py-0.5 rounded-full min-w-[18px] text-center">
              {cartCount}
            </span>
          )}
        </div>
        <span>Корзина</span>
      </NavLink>

      <NavLink
        to="/orders"
        className={({ isActive }) =>
          cn(
            "flex flex-col items-center gap-1 px-4 py-2 text-xs transition-colors",
            isActive ? "text-primary" : "text-muted-foreground"
          )
        }
      >
        <Package className="h-6 w-6" />
        <span>Заказы</span>
      </NavLink>
    </nav>
  );
}
